<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :data="vtableData"
      :columns="tableColumns"
      size="mini"
    >
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    orderNo: String,
  },
  data() {
    return {
      vtableData: [],
      tableColumns: tableColumns(),
    }
  },
  watch: {
    // // 避免父组件重新渲染子组件机制警告
    // waybillCode: {
    //   handler(waybillCode) {
    //     if (waybillCode) {
    //       this.waybillCode = waybillCode
    //     }
    //   },
    //   immediate: true,
    // },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$api
        .carriageWaybillDetailMaptrackingListApi({
          keyword: this.orderNo,
        })
        .then((res) => {
          this.vtableData = res.body.data
        })
    },
    async getTableData() {
      const $table = this.$refs.table
      return await $table.getTableData().tableData
    },
    validEvent() {
      return this.$refs.table
        .fullValidate()
        .then(() => true)
        .catch(() => false)
    },
  },
}
</script>
